<template>
  <div>
    <!-- Agent Dashboard Section -->
    <div class="agent-dashboard-section">
      <v-container class="fill-height">
        <v-layout column>
          <!-- Header Section -->
          <div class="dashboard-header py-6">
            <div class="d-flex justify-center align-center">
              <div class="header-content d-flex align-center">
                <img
                  src="@/assets/images/freed-small-logo.svg"
                  alt="Freed Logo"
                  class="freed-logo mr-3"
                />
                <h1 class="dashboard-title">FPP - DSA Dashboard</h1>
              </div>
            </div>
          </div>
          <!-- Filter and Performance Overview Section -->
          <f-p-p-sales-dashboard-filter-metrics
            v-if="dsaAgentPerformanceInfo"
            :dsaAgentPerformanceData="
              dsaAgentPerformanceInfo.dsaAgentPerformanceData
            "
            :selectedFilter="selectedFilter"
            :customDateRange="customDateRange"
            :metrics="metrics"
            @filterChanged="applyFilter"
            @dateRangeChanged="handleCustomDateRangeSelect"
            @navigateToDetails="navigateToDetails"
          ></f-p-p-sales-dashboard-filter-metrics>
        </v-layout>
      </v-container>
    </div>

    <!-- Enter Mobile Number Section -->
    <div v-if="showMobileNumberForm" class="mobile-number-section">
      <v-container>
        <v-card class="mobile-number-card">
          <v-card-title v-if="addPartnerClientFFormMetaData.props.title">
            {{ addPartnerClientFFormMetaData.props.title }}
          </v-card-title>
          <component
            :is="addPartnerClientFFormMetaData.componentName"
            :ref="addPartnerClientFFormMetaData.myRefName"
            :value="selectModel(addDsaClientDraftInput, undefined)"
            @input="
              (newValue) =>
                updateModel(addDsaClientDraftInput, newValue, undefined)
            "
            v-bind="addPartnerClientFFormMetaData.props"
          ></component>
        </v-card>
      </v-container>
    </div>

    <!-- Lead File Status Section -->

    <div class="lead-file-section">
      <v-container>
        <component
          v-if="!!leadFDataTableMetaData"
          :ref="leadFDataTableMetaData.myRefName"
          :is="leadFDataTableMetaData.componentName"
          :value="getDsaAgentDashboardDataOutput.dsaAgentDashboardDataList"
          v-bind="leadFDataTableMetaData.props"
        >
        </component>
      </v-container>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import FForm from "@/components/form/FForm.vue";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import FPPSalesDashboardLeadFDataTableMDP from "./FPPSalesDashboardLeadFDataTableMDP";
import AddPartnerClientFFormMDP from "./AddPartnerClientFFormMDP";
import FSnackbar from "@/fsnackbar";
import FDataTable from "@/components/table/FDataTable.vue";
import { VCard } from "vuetify/lib";
import ModelVue from "@/components/ModelVue";
import FPPSalesDashboardUserInfo from "./FPPSalesDashboard/FPPSalesDashboardUserInfo.vue";
import FPPSalesDashboardFilterMetrics from "./FPPSalesDashboard/FPPSalesDashboardFilterMetrics.vue";
import Helper from "@/util/Helper";
import FCellCopy from "@/components/table/cell/FCellCopy.vue";

@Component({
  components: {
    FForm,
    FDataTable,
    FPPSalesDashboardUserInfo,
    FPPSalesDashboardFilterMetrics,
    FCellCopy,
  },
})
export default class FPPSalesDashboard extends ModelVue {
  @Store.Getter.Partner.ApplicantDetails.PartnerInfo
  PartnerInfo: Data.Partner.PartnerSummary;

  dsaAgentDashboardinput: Data.Partner.DsaAgentDashboardInput =
    new Data.Partner.DsaAgentDashboardInput();

  getDsaAgentDashboardDataOutput: Data.Partner.GetDsaAgentDashboardDataOutput =
    new Data.Partner.GetDsaAgentDashboardDataOutput();

  dsaAgentPerformanceInfo: any = new Data.Partner.DsaAgentPerformanceData();
  addDsaClientDraftInput: Data.Partner.AddDsaClientDraftInput =
    new Data.Partner.AddDsaClientDraftInput();

  selectedFilter: string = "today";
  customDateRange: [string, string] = ["", ""];
  showMobileNumberForm: boolean = false;
  onboardingLink: string = "";
  metrics: any = {
    totalLinksSent: 0,
    totalSignups: 0,
    verifiedCreditPulls: 0,
    eligibleClients: 0,
    ineligibleClients: 0,
    transferred: 0,
  };

  get leadFDataTableMetaData() {
    return new FPPSalesDashboardLeadFDataTableMDP({
      parent: this,
    }).getMetaData();
  }

  get addPartnerClientFFormMetaData(): any {
    return new AddPartnerClientFFormMDP({ root: this }).getMetaData();
  }

  applyFilter(filterValue: string) {
    this.selectedFilter = filterValue;
    this.filterAPI(filterValue);
  }

  handleCustomDateRangeSelect(dates: [string, string]) {
    this.customDateRange = dates;
    this.dsaAgentDashboardinput.fromDate = dates[0];
    this.dsaAgentDashboardinput.toDate = dates[1];
    this.getDsaAgentDashboardData();
    this.getDsaAgentPerformanceData();
  }

  navigateToDetails(type: string) {}

  filterAPI(filter: string) {
    switch (filter) {
      case "today":
        this.dsaAgentDashboardinput.fromDate =
          Helper.dateMTDWithCurrent().currentDate;
        this.dsaAgentDashboardinput.toDate =
          Helper.dateMTDWithCurrent().currentDate;
        break;
      case "last7Days":
        this.dsaAgentDashboardinput.fromDate =
          Helper.dateMTDWithCurrent().last7DaysToDate;
        this.dsaAgentDashboardinput.toDate =
          Helper.dateMTDWithCurrent().currentDate;
        break;
      case "last30Days":
        this.dsaAgentDashboardinput.fromDate =
          Helper.dateMTDWithCurrent().thirtyDaysAgo;
        this.dsaAgentDashboardinput.toDate =
          Helper.dateMTDWithCurrent().currentDate;
        break;
      case "custom":
        if (this.customDateRange[0] && this.customDateRange[1]) {
          this.dsaAgentDashboardinput.fromDate = this.customDateRange[0];
          this.dsaAgentDashboardinput.toDate = this.customDateRange[1];
        } else {
          this.dsaAgentDashboardinput.fromDate =
            Helper.dateMTDWithCurrent().startOfMonth;
          this.dsaAgentDashboardinput.toDate =
            Helper.dateMTDWithCurrent().currentDate;
        }
        break;
      default:
        this.dsaAgentDashboardinput.fromDate =
          Helper.dateMTDWithCurrent().currentDate;
        this.dsaAgentDashboardinput.toDate =
          Helper.dateMTDWithCurrent().currentDate;
        break;
    }
    this.getDsaAgentDashboardData();
    this.getDsaAgentPerformanceData();
  }

  mounted() {
    this.filterAPI("today");
  }

  addDsaClientDraft() {
    console.log(
      "Adding DSA Client Draft for mobile:",
      this.addDsaClientDraftInput
    );
    Action.Partner.AddDsaClientDraft.execute1(
      this.addDsaClientDraftInput.mobile,
      (output) => {
        this.resetDsaClientDraftClientform();
        this.showMobileNumberForm = false;
        // Refresh lead file status table
        this.getDsaAgentDashboardData();
        FSnackbar.success("DSA Client Draft Added Successfully");
      },
      (error) => {
        const errorData = error?.response?.data;
        const errorMessage = Array.isArray(errorData) 
          ? errorData.find((err: any) => err.message === "Mobile already registered with partner")?.message
          : null;
        FSnackbar.error(errorMessage || "Error adding DSA Client Draft");
      }
    );
  }

  showAddClientForm() {
    this.showMobileNumberForm = true;
  }

  sendDsaCustomerOnboardingLinkToCustomer() {
    Action.Partner.SendDsaCustomerOnboardingLinkToCustomer.execute1(
      this.addDsaClientDraftInput.mobile,
      (output): void => {
        FSnackbar.success("Onboarding Link Sent Successfully");
        this.onboardingLink = output; // Store the link URL
        this.resetDsaClientDraftClientform();
      },
      (error) => {
        FSnackbar.error("Error sending Onboarding Link");
        this.onboardingLink = "";
      }
    );
  }

  handleSendWhatsAppLink() {
    if (
      !this.addDsaClientDraftInput.mobile ||
      !this.addDsaClientDraftInput.mobile.trim()
    ) {
      FSnackbar.error("Please enter a mobile number");
      return;
    }
    this.sendDsaCustomerOnboardingLinkToCustomer();
  }

  resetDsaClientDraftClientform() {
    this.addDsaClientDraftInput = new Data.Partner.AddDsaClientDraftInput();
    this.onboardingLink = "";
  }

  getDsaAgentDashboardData(showSuccessMessage: boolean = false) {
    this.dsaAgentDashboardinput.offset = 0;
    this.dsaAgentDashboardinput.count = 1000;
    Action.Partner.GetDsaAgentDashboardData.execute(
      this.dsaAgentDashboardinput,
      (output) => {
        if (output == null) {
          if (showSuccessMessage) {
            FSnackbar.error("Error refreshing data");
          }
          return;
        }
        this.getDsaAgentDashboardDataOutput = output;
        if (showSuccessMessage) {
          FSnackbar.success("Data refreshed successfully");
        }
      },
      (error) => {
        console.error("Error fetching DSA Agent Dashboard Data", error);
        if (showSuccessMessage) {
          FSnackbar.error("Error refreshing data");
        }
      }
    );
  }

  getDsaAgentPerformanceData() {
    console.log(
      "Fetching DSA Agent Performance Data",
      this.dsaAgentDashboardinput
    );
    Action.Partner.GetDsaAgentPerformanceData.execute(
      this.dsaAgentDashboardinput,
      (output) => {
        if (output == null) {
          return;
        }
        console.log("Received DSA Agent Performance Data", output);
        this.dsaAgentPerformanceInfo = output;
      },
      (error) => {
        console.error("Error fetching DSA Agent Performance Data", error);
      }
    );
  }

  refreshLeadList() {
    this.getDsaAgentDashboardData(true);
    this.getDsaAgentPerformanceData();
  }

  generateAttributionCodeForLead(item: any) {
    if (!item || !item.mobile) {
      FSnackbar.error("Mobile number not available");
      return;
    }
    Action.Partner.GenerateAttributionCode.execute1(
      item.mobile,
      (output): void => {
        if (output && output.attributionCode) {
          item.attributionCode = output.attributionCode;
          FSnackbar.success("Attribution code generated successfully");
        } else {
          FSnackbar.error("Failed to generate attribution code");
        }
      },
      (error) => {
        FSnackbar.error("Error generating attribution code");
      }
    );
  }

  sendWhatsAppLinkForLead(item: any) {
    if (!item || !item.mobile) {
      FSnackbar.error("Mobile number not available");
      return;
    }
    Action.Partner.SendDsaCustomerOnboardingLinkToCustomer.execute1(
      item.mobile,
      (output): void => {
        if (output) {
          item.dsaCustomerOnboardingLink = output;
          FSnackbar.success("WhatsApp link sent successfully");
        } else {
          FSnackbar.error("Link not available");
        }
      },
      (error) => {
        FSnackbar.error("Error sending link");
      }
    );
  }

  copyLinkForLead(item: any) {
    if (!item || !item.mobile) {
      FSnackbar.error("Mobile number not available");
      return;
    }
    const existingLink =
      item.dsaCustomerOnboardingLink || item.onboardingLink || item.signupLink;
    if (existingLink) {
      Helper.copyToClipBoard(existingLink);
    } else {
      Action.Partner.SendDsaCustomerOnboardingLinkToCustomer.execute1(
        item.mobile,
        (output): void => {
          if (output) {
            item.dsaCustomerOnboardingLink = output;
            Helper.copyToClipBoard(output);
          } else {
            FSnackbar.error("Link not available");
          }
        },
        (error) => {
          FSnackbar.error("Error fetching link");
        }
      );
    }
  }
}
</script>

<style lang="scss" scoped>
.agent-dashboard-section {
  background-color: #ffffff;
  width: 100%;
  // padding: 24px 0;
}

.mobile-number-section {
  background-color: #ffffff;
  width: 100%;
  // padding: 24px 0;
}

.mobile-number-card {
  border: 1px solid var(--primary-color) !important;
}

.lead-file-section {
  width: 100%;
  padding: 20px 0;
}

.dashboard-title {
  font-size: 28px;
  color: #00447a;
}

.freed-logo {
  height: 40px;
  width: auto;
}

@media (min-width: 1264px) {
  ::v-deep .container {
    max-width: 1440px;
  }
}
</style>
